import { AuthenticationService, AuthService } from '../services/AuthService'
import { GuestbookClient } from '../services/GuestbookClient'
import { DefaultUserClient, UserClient } from '../services/UserClient'
import { memoize } from '@/utils'
import { WebApplicationStore } from './WebAppStore'
import { DeviceStoreSchema } from './store-schema'

export interface Services {
  auth: AuthenticationService
  deviceStore: WebApplicationStore<DeviceStoreSchema>
  guestbookClient: GuestbookClient
  userClient: UserClient
}

export const getServices = memoize((): Services => {
  const deviceStore = new WebApplicationStore<DeviceStoreSchema>(
    import.meta.env.DEV ? 'pgb-dev' : 'pgb',
    localStorage,
  )
  const auth = new AuthService()
  const guestbookClient = new GuestbookClient(auth)
  const userClient = new DefaultUserClient(auth)
  return {
    auth,
    deviceStore,
    guestbookClient,
    userClient,
  }
})
